import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface Demo {
  IdEmpleado: number;
  NumeroEmpleados: number;
  NombreCompleto: string;
  Empresa: string;
  Provincia: string;
  Telefono: string;
  Email: string;
  PersonaContacto: string;
  Observaciones: string;
  SolicitaDemo: boolean;
  EnviarInfo: boolean;
}

interface RespuestaBasica {
  TodoOk: boolean;
  Mensaje: string;
}

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  // baseUrlAPI = 'https://portal.mpecronos.com';
  baseUrlAPI = 'https://portal.horax3.com';
  //baseUrlAPI = "http://localhost:30050/";
  header = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient) {}

  solicitaDemo(demo: Demo) {
    const datos = this.http
      .post<RespuestaBasica>(
        `${this.baseUrlAPI}/api/Comercial/SolicitarDemo`,
        demo,
        { headers: this.header }
      )
      .toPromise();
    return datos;
  }
}
